import { BackendUser, CommentPost } from "common/types"
import { CustomIconContextMenu } from "components/core/actions-menu-noborder/CustomIconContextMenu"
import { useScreenSizes } from "hooks/use-screen-sizes/useScreenSizes"
import { ReactComponent as ActionContextIcon } from 'icons/action-context-icon.svg'
import { useTheme } from 'styled-components'
import { StyledDeleteIcon, StyledReportIcon } from "../styled"
import { useState } from "react"
import { ContextMenuButton } from "../components/ContextMenuButton"

interface IUseCommentsContextMenu {
    comment: CommentPost
    user: BackendUser
    post: any
    isReported: Function
}

export const useCommentsContextMenu = ({ comment, user, post, isReported }: IUseCommentsContextMenu) => {
    const { isDevice } = useScreenSizes()
    const theme = useTheme()
    const [showDelete, setShowDelete] = useState(false)
    const [showReportComment, setShowReportComment] = useState<any>(false)

    const returnContextMenu = () => {
        if (!isDevice && comment?.id === user?.id && post?.userId !== user?.id) {
            return <></>
        }
        //Isn't my comment, but my post, and comment isn't reported
        if (isDevice && comment?.userId !== user?.id && post?.userId === user?.id && !isReported()) {
            return (
                <>
                    <CustomIconContextMenu
                        title=""
                        icon={<ActionContextIcon fill={theme.colors.accent1} />}
                        noPadding={true}
                    >
                        <ContextMenuButton icon={<StyledDeleteIcon />} text="Delete" onClick={() => setShowDelete(true)} />

                        <ContextMenuButton icon={<StyledReportIcon />} text=" Report Comment" onClick={() => setShowReportComment(true)} disabled={isReported()} />
                    </CustomIconContextMenu>
                </>
            )
        }
        //Isn't my comment or post and hasn't been reported
        if (isDevice && comment?.userId !== user?.id && post?.userId !== user?.id && !isReported()) {
            return (
                <>
                    <CustomIconContextMenu
                        title=""
                        icon={<ActionContextIcon fill={theme.colors.accent1} />}
                        noPadding={true}
                    >
                        <ContextMenuButton icon={<StyledReportIcon />} text=" Report Comment" onClick={() => setShowReportComment(true)} disabled={isReported()} />
                    </CustomIconContextMenu>
                </>
            )
        }
        //Isn't my comment, but it's my post and the comment is reported
        if (isDevice && comment?.userId !== user?.id && post?.userId === user?.id && isReported()) {
            return (
                <>
                    <CustomIconContextMenu
                        title=""
                        icon={<ActionContextIcon fill={theme.colors.accent1} />}
                        noPadding={true}
                    >
                        <ContextMenuButton icon={<StyledDeleteIcon />} text="Delete" onClick={() => setShowDelete(true)} />
                    </CustomIconContextMenu>
                </>
            )
        }
        //isn't my comment or post and hasn't been reported
        if (isDevice && comment?.userId !== user?.id && post?.userId !== user?.id && !isReported()) {
            return (
                <>
                    <CustomIconContextMenu
                        title=""
                        icon={<ActionContextIcon fill={theme.colors.accent1} />}
                        noPadding={true}
                    >
                        <ContextMenuButton icon={<StyledReportIcon />} text="Report Comment" onClick={() => setShowReportComment(true)} disabled={isReported()} />
                    </CustomIconContextMenu>
                </>
            )
        }
        //Isn't my comment, isn't my post and the comment is reported
        if (isDevice && comment?.userId !== user?.id && post?.userId !== user?.id && isReported()) {
            return <></>
        }
        //Isn't my comment, it's my post, and isn't reported (full screen)
        if (!isDevice && comment?.userId !== user?.id && post?.userId === user?.id && !isReported()) {
            return (
                <>
                    <CustomIconContextMenu title="" icon={<ActionContextIcon fill={theme.colors.accent1} />}>
                        <ContextMenuButton icon={<StyledDeleteIcon />} text="Delete" onClick={() => setShowDelete(true)} />

                        <ContextMenuButton icon={<StyledReportIcon />} text="Report Comment" onClick={() => setShowReportComment(true)} disabled={isReported()} />
                    </CustomIconContextMenu>
                </>
            )
        }
        //Isn't my comment, it's my post, and it is reported (full screen)
        if (!isDevice && comment?.userId !== user?.id && post?.userId === user?.id && isReported()) {
            return (
                <>
                    <CustomIconContextMenu title="" icon={<ActionContextIcon fill={theme.colors.accent1} />}>
                        <ContextMenuButton icon={<StyledDeleteIcon />} text="Delete" onClick={() => setShowDelete(true)} />
                    </CustomIconContextMenu>
                </>
            )
        }
        //Isn't my comment, isn't my post, comment hasn't been reported
        if (!isDevice && comment?.userId !== user?.id && post?.userId !== user?.id && !isReported()) {
            return (
                <>
                    <CustomIconContextMenu title="" icon={<ActionContextIcon fill={theme.colors.accent1} />}>
                        <ContextMenuButton icon={<StyledReportIcon />} text="Report Comment" onClick={() => setShowReportComment(true)} disabled={isReported()} />
                    </CustomIconContextMenu>
                </>
            )
        }
        //isn't my comment, isn't my post, has been reported
        if (!isDevice && comment?.userId !== user?.id && post?.userId !== user?.id && isReported()) {
            return <></>
        }
    }


    return {
        returnContextMenu,
        showDelete,
        setShowDelete,
        showReportComment,
        setShowReportComment
    } as const
}
